/*
 * This module provides access to the gdpr request functions of the server.
 */
angular.module('services.gdprrequest', ['http.gdprrequest']).factory('GdprRequestService', [
  'httpGdprRequest',
  'httpQueue',
  function (httpGdprRequest, httpQueue) {
    // Expose the functions only, not the data
    return {
      getPreSignedPostUrl,
      submitGdprVerification,
      submitGdprRequest,
      getBatchDetails
    };

    /**
     * Returns a pre-signed URL for uploading a file to S3.
     *
     * @param {Number} timestamp - The timestamp to use when signing.
     * @returns {Promise<String>} - A promise that resolves to the URL.
     */
    function getPreSignedPostUrl(timestamp) {
      return httpGdprRequest.getPreSignedPostUrl(timestamp);
    }

    /**
     * Submits a gdpr request CSV verification to be queued.
     *
     * @params {object} gdprRequestData - the configured settings for the gdpr request.
     * @params {number} timestamp - the timestamp used when the file was uploaded.
     * @params {string} gdprOperation - the gdpr operation type
     * @returns {Promise} A promise that resolves to the queue result if the CSV verification was successful.
     */
    function submitGdprVerification(gdprRequestData, timestamp, gdprOperation) {
      const params = {
        uploadTimestamp: timestamp,
        verification: true,
        jobType: gdprOperation
      };

      return httpQueue.submitGdprOperation(params).then(function (res) {
        if (res.status === 0) {
          return res;
        } else {
          return Promise.reject(res);
        }
      });
    }

    /**
     * Submits a gdpr actual request to perform the work to be queued.
     *
     * @param {number} verificationBatchId - gdpr verification batch id
     * @returns {Promise} A promise that resolves to the queue result if the queue operation was successful.
     */
    function submitGdprRequest(verificationBatchId) {
      const params = {
        verificationBatchId
      };
      return httpQueue.submitGdprOperation(params).then(function (res) {
        if (res.status === 0) {
          return res;
        } else {
          return Promise.reject(res);
        }
      });
    }

    /**
     * Get batch details
     * @param {any} params
     * @returns {any}
     */
    function getBatchDetails(params) {
      return httpGdprRequest.getDetails(params);
    }
  }
]);
